module.exports = __webpack_public_path__ + "img/05_Screenshot 2025-06-13 at 14.01.34.b5a631c8.jpg";